const Notes = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33268 2.33333V4.13333C9.33268 5.25344 9.33268 5.81349 9.55067 6.24131C9.74242 6.61764 10.0484 6.9236 10.4247 7.11535C10.8525 7.33333 11.4126 7.33333 12.5327 7.33333H14.3327M14.666 8.65882V10.8C14.666 11.9201 14.666 12.4802 14.448 12.908C14.2563 13.2843 13.9503 13.5903 13.574 13.782C13.1462 14 12.5861 14 11.466 14H5.86602C4.74591 14 4.18586 14 3.75803 13.782C3.38171 13.5903 3.07575 13.2843 2.884 12.908C2.66602 12.4802 2.66602 11.9201 2.66602 10.8V5.2C2.66602 4.0799 2.66602 3.51984 2.884 3.09202C3.07575 2.71569 3.38171 2.40973 3.75803 2.21799C4.18586 2 4.74591 2 5.86602 2H8.0072C8.49638 2 8.74097 2 8.97115 2.05526C9.17522 2.10425 9.37031 2.18506 9.54925 2.29472C9.75109 2.4184 9.92404 2.59135 10.2699 2.93726L13.7288 6.39608C14.0747 6.74198 14.2476 6.91493 14.3713 7.11676C14.481 7.29571 14.5618 7.4908 14.6108 7.69487C14.666 7.92505 14.666 8.16964 14.666 8.65882Z"
      stroke="#B93DAE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Notes;
